(ns rothko.accessibility.screen-reader-text)

(defn component
  [text]
  [:span
   {:style {:position :absolute
            :height 1
            :width 1
            :overflow :hidden}}
   text])
